import { render, staticRenderFns } from "./GetCustomerConsumptions.vue?vue&type=template&id=565cd928&scoped=true&"
import script from "./GetCustomerConsumptions.vue?vue&type=script&lang=js&"
export * from "./GetCustomerConsumptions.vue?vue&type=script&lang=js&"
import style0 from "./GetCustomerConsumptions.vue?vue&type=style&index=0&id=565cd928&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565cd928",
  null
  
)

export default component.exports